
var loadings = <any>null;
import checkout from "../alp-check/checkout.vue";
import checkGroup from "../alp-check/checkGroup.vue";
// 中文配置
import zhCN from "ant-design-vue/es/locale/zh_CN";
import {
  defineComponent,
  getCurrentInstance,
  reactive,
  ref,
  createVNode,
  onMounted,
  toRefs,
  UnwrapRef,
  watch,
} from "vue";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import JsxTemp from "./demo.jsx";
//深拷贝
function clone(obj) {
  let newobj = <any>null; // 接受拷贝的新对象
  if (typeof obj == "object" && typeof obj !== null) {
    // 判断是否是引用类型
    newobj = obj instanceof Array ? [] : {}; // 判断是数组还是对象
    for (var i in obj) {
      newobj[i] = clone(obj[i]); // 判断下一级是否还是引用类型
    }
  } else {
    newobj = obj;
  }
  return newobj;
}
export default defineComponent({
  name: "alpTable",
  components: {
    checkout,
    checkGroup,
    JsxTemp,
  },
  props: {
    //表格配置
    formTableConfigs: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    //组件高度
    height() {
      if (typeof this.formTableOption.height === "number") {
        return this.formTableOption.height + "px";
      } else {
        return this.formTableOption.height;
      }
    },
    //组件宽度
    width() {
      if (typeof this.formTableOption.width === "number") {
        return this.formTableOption.width + "px";
      } else {
        return this.formTableOption.width;
      }
    },
    formTableOption() {
      return Object.assign(
        {
          key: "alpTable",
          //组件宽度
          width: "",
          //组件高度
          height: "",
          //页面标题
          pageTitle: "",
          //表格模式(默认弹出增加数据，other行内编辑)
          model: "default",
          //是否显示分页
          showPagination: true,
          //是否显示表格以上内容
          showTop: true,
          //顶部合并(仅适用于顶部表单框及按钮很少的情况)
          topMerge: false,
          //隐藏查询
          hiddenSearch: false,
          //是否显示查询form
          showSearch: true,
          //新增弹窗宽度
          modalWidth: 520,
          //是否支持选中
          selected: true,
          //收起处理表格
          shrinkTable: false,
          formTemplate: reactive({}),
          //隐藏按钮列表
          hiddenTopBtn: [],
          //表格是否支持编辑
          editTable: true,
          //是否多选 radio单选  checkbox多选
          selectedType: "radio",
          //滚动动画
          scrollAnimate: false,
          //单选清空选择
          radioReset: true,
          //横向滚动
          tableX: "true",
          //是否显示表格内编辑
          showTableEdit: true,
          topForm: reactive({}),
          tableRowForm: reactive({}),
          customRow: undefined,
          //原生
          _attr: {},
          //唯一标识
          majorKey: "id",
          //滚动高度
          tableViewHeight: 400,
          //顶部按钮权限
          btnPower: {
            search: undefined, //顶部查询
            add: undefined, //顶部新增
            edit: undefined, //顶部编辑
            reset: undefined, //顶部重置
            save: undefined, //顶部保存
            upload: undefined, //顶部上传
            cancel: undefined, //顶部取消
            tableEdit: undefined, //表格编辑
          },
          //上传配置
          uploadConfig: {
            //是否多文件上传
            multiple: false,
            // 文件类型
            accept: "xlsx",
            headers: {
              token: "",
            },
            //上传地址
            action: "",
            fileList: [],
          },
          //是否收缩
          isShrink: true,
          //顶部按钮
          topBtnList: [],
          //表格按钮
          tableBtnList: [],
          //表格更多菜单
          tableMoreMenuList: [],
          //表格数据
          tableData: ref([]),
          //表格列
          columns: ref([]),
          //分页
          pagination: {
            showTotal: (total) => `共 ${total} 条`,
            total: 0,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "30", "50"],
            current: 1,
            pageSize: 10,
          },
          //弹出配置
          modalConfig: reactive({
            show: false,
            data: [],
            editData: null,
            loading: false,
          }),
        },
        this.formTableConfigs
      );
    },
    //选中配置项
    rowSelection(row) {
      let { selectedRowKeys } = this;
      let obj = {};
      if (this.formTableOption.selected) {
        obj = {
          selectedRowKeys,
          onChange: this.tableFunction.onSelectChange,
          type: this.formTableOption.selectedType,
          columnWidth: this.formTableOption.selectedWidth,
        };
      } else {
        obj = "";
      }
      return obj;
    },
    // 表格过滤列
    tableColumns: function () {
      this.slot.table = [];
      let columns = (this as any).formTableConfigs.columns;
      let colArr = <any>[];
      let newArr = <any>[];
      //处理列数据
      const arrReduces = function (someArr) {
        for (let i = 0; i < someArr.length; i++) {
          if (
            someArr[i].hasOwnProperty("children") &&
            Array.isArray(someArr[i].children)
          ) {
            arrReduces(someArr[i].children);
          } else {
            colArr.push(someArr[i]);
          }
        }
      };
      if (columns && Array.isArray(columns) && columns.length) {
        arrReduces(columns);
      }
      colArr.forEach((col) => {
        if (col.key !== "options") {
          newArr.push(col);
        }
        if ((col.soltName || col.slotName) && col.custom) {
          //调整插槽名称问题
          if (col.slotName) {
            col.soltName = col.slotName;
          }
          (this as any).slot.table.push(col);
        }
      });
      return newArr;
    },
  },
  data: function () {
    return {
      showTopForm: true,
      //表单渲染用
      topFormKey: 1,
      modelFormkey: 1,
      //表格原生
      a_attr: "",
      //modal框body样式
      bodyStyle: {
        height: "500px",
        overflow: "auto",
      },
      tableData: ref([]),
      //顶部收缩
      topFormShrink: false,
      hiddenTable: true,
      topFormHeight: ref(0),
      //当前控件状态
      formState: "select",
      //顶部数据
      topFormData: reactive({}),
      //插槽
      slot: {
        top: [],
        modal: [],
        table: [],
      },
      //表格选中数据
      selectedRowKeys: ref([]),
      //当前点击行
      nowClickRow: {},
      //当前复选框选中数据
      selectedData: [],
      formTemplate: reactive({}),
      //table新增数据
      tableRowFormData: reactive({}),
      //操作行
      editRow: {},
      tableKey: 1,
      //排序
      sorter: {},
      //过滤
      filters: {},
      //滚动区域高度
      scrollHeight: 0,
      //顶部按钮权限
      topPowerList: [],
    };
  },
  //初始化
  setup(props, content) {
    let topForms = reactive({});
    //筛选条件
    const state = reactive({
      searchText: <any>null,
      searchedColumn: <any>null,
    });
    let colArr = <any>[];

    //获取vue实例
    const proxy: any = getCurrentInstance()?.proxy; //获取vue实例上下文
    watch(
      () => props.formTableConfigs.topForm,
      (newValue, oldValue) => {
        let form = proxy.$refs["topForm"]; //获取表单
        if (form) {
          let obj = form.getFormData().form;
          //获取当前值
          let data = JSON.parse(JSON.stringify(form.getFormData().formData));
          let formData = form.getFormData().formData;
          //重新获取字典
          form.getDicts(proxy.formTableOption.topForm);
          newValue.form.forEach((item, index) => {
            obj[index] = newValue.form[index];
          });
          //改为当前值
          for (const key in data) {
            if (
              data[key].value !== "" &&
              data[key].value !== undefined &&
              data[key].value !== []
            ) {
              formData[key] = data[key];
            }
          }
        }
      },
      { deep: true }
    );
    watch(
      () => props.formTableConfigs.tableRowForm,
      (newValue, oldValue) => {
        proxy.$nextTick(() => {
          let form = proxy.$refs["rowForm"]; //获取表单
          if (form) {
            let obj = form.getFormData().form;
            //获取当前值
            let data = JSON.parse(JSON.stringify(form.getFormData().formData));
            let formData = form.getFormData().formData;
            //重新获取字典
            form.getDicts(proxy.formTableOption.tableRowForm);
            newValue.form.forEach((item, index) => {
              obj[index] = newValue.form[index];
            });
            //改为当前值
            for (const key in data) {
              if (
                data[key].value !== "" &&
                data[key].value !== undefined &&
                data[key].value !== []
              ) {
                formData[key] = data[key];
              }
            }
          }
        });
      },
      { deep: true }
    );

    onMounted(() => {
      //重新计算高度
      proxy.getTableViewHeight();
    });
    //处理列数据
    const arrReduce = function (someArr) {
      for (let i = 0; i < someArr.length; i++) {
        if (
          someArr[i].hasOwnProperty("children") &&
          Array.isArray(someArr[i].children)
        ) {
          arrReduce(someArr[i].children);
        } else {
          colArr.push(someArr[i]);
        }
      }
    };
    const editableData: UnwrapRef<Record<string, boolean>> = reactive({});
    //获取字典项(并处理成数组及map用于显示及填写使用)
    let optionsObj = reactive({});
    const getOptions = function () {
      return new Promise<void>((resolve, reject) => {
        let column = proxy.formTableOption.columns;
        if (column && Array.isArray(column) && column.length) {
          //转为一维数组
          arrReduce(column);
        }
        colArr.forEach((item) => {
          if (item.options) {
            optionsObj[item.key + "list"] = item.options;
            item.options.forEach((val) => {
              if (!optionsObj.hasOwnProperty(item.key + "map")) {
                optionsObj[item.key + "map"] = {};
                ("");
              }
              optionsObj[item.key + "map"][val.value] = val.label;
            });
            resolve();
          }
          if (item.dictKey && !item.options) {
            proxy.$dict(item.dictKey).then((res) => {
              optionsObj[item.key + "list"] = res;
              res.forEach((val) => {
                if (!optionsObj.hasOwnProperty(item.key + "map")) {
                  optionsObj[item.key + "map"] = {};
                  ("");
                }
                optionsObj[item.key + "map"][val.value] = val.label;
              });
              resolve();
            });
          }
        });
      });
    };
    /* 顶部按钮方法 */
    const topFunction = {
      topOperate: function (type, datas) {
        if (type === "add" || type === "select" || type === "edit") {
          proxy.setFormState(type);
        }
        let form = proxy.$refs["topForm"]; //获取表单
        let data = {
          type,
          formData: proxy.handleFormData(),
          selectedData: proxy.selectedData,
          table: proxy.formTableOption.tableData,
          state: proxy.formState,
          fileList: [],
        };
        if (proxy.slot.top.length !== 0) {
          proxy.slot.top.forEach((item) => {
            data.formData[item.soltName] =
              proxy.formTableConfigs.slotData[item.soltName] || "";
          });
        }
        switch (type) {
          //查询
          case "search":
            proxy.selectedRowKeys = [];
            proxy.selectedData = [];
            proxy.$emit("topOperate", data, (res) => {
              proxy.formState = "select";
            });
            break;
          // 重置
          case "reset":
            //清空
            form.resetValidation();
            proxy.selectedRowKeys = [];
            proxy.selectedData = [];
            proxy.formState = "select";
            data.formData = proxy.handleFormData(true);
            proxy.$emit("topOperate", data, (res) => {
              proxy.formState = "select";
            });
            break;
          // 新增
          case "add":
            proxy.formState = "add";
            //default模式
            if (proxy.formTableOption.model === "default") {
              for (var k in proxy.formTableOption.formTemplate) {
                proxy.tableRowFormData[k] = {
                  value: proxy.formTableOption.formTemplate[k],
                };
              }
              proxy.formTableOption.modalConfig.editData = null;
              proxy.$emit("topOperate", data, (res) => {
                proxy.setFormState(res);
              });
              proxy.formTableOption.modalConfig.show = true;
            } else {
              // 新增
              proxy.tableFunction.clearAll();
              let newRow = clone(proxy.formTableOption.formTemplate);
              newRow._edit = true;
              newRow.id = proxy.formTableOption.majorKey;
              proxy.formTableOption.tableData.push(newRow);
              props.formTableConfigs.tableData = [].concat(
                proxy.formTableOption.tableData
              );
              proxy.selectedRowKeys = [newRow.id];
              let ele = <any>null;
              proxy.$nextTick(() => {
                setTimeout(() => {
                  ele = proxy.$el.querySelector(".tableView");
                  let elc = ele.querySelector(".surely-table-body");
                  //判断元素是否出现了滚动条
                  if (elc.scrollHeight > elc.clientHeight) {
                    //开启动画
                    if (proxy.formTableOption.scrollAnimate) {
                      //设置滚动条到最底部
                      proxy.animateTo(elc, elc.scrollTop, elc.scrollHeight);
                    } else {
                      elc.scrollTop = elc.scrollHeight;
                    }
                  }
                });
              });
            }
            break;
          //删除
          case "delete":
            // 删除
            var that = proxy;
            that.$confirm({
              title: () => "删除",
              icon: () => createVNode(ExclamationCircleOutlined),
              content: () => "确定要删除吗？",
              cancelText: () => "取消",
              okText: () => "确认",
              onOk() {
                return new Promise((resolve) => {
                  that.$emit("topOperate", data, (res) => {
                    proxy.formState = "select";
                    proxy.selectedRowKeys = [];
                    proxy.selectedData = [];
                    resolve(true);
                  });
                });
              },
              onCancel() {},
            });
            break;
          //编辑
          case "edit":
            proxy.formState = "edit";
            if (proxy.formTableOption.model === "default") {
              if (proxy.selectedData.length === 0) {
                proxy.$message.warning("请选择记录");
                proxy.formState = "select";
                return;
              }
              for (var k in proxy.formTemplate) {
                proxy.tableRowFormData[k] = {
                  value: proxy.selectedData[0][k]
                    ? proxy.selectedData[0][k]
                    : proxy.selectedData[0][k] === 0
                    ? 0
                    : proxy.formTemplate[k],
                };
              }
              proxy.formTableOption.modalConfig.editData =
                proxy.tableRowFormData;
              proxy.$emit("topOperate", data, (res) => {
                proxy.setFormState(res);
              });
              proxy.formTableOption.modalConfig.show = true;
            } else {
              proxy.formTableOption.tableData.forEach((item) => {
                item._edit = true;
              });
            }
            break;
          //取消
          case "cancel":
            proxy.selectedRowKeys = [];
            proxy.selectedData = [];
            // 新增删除最后新增数据
            if (proxy.formState === "add") {
              proxy.formTableOption.tableData.pop();
              proxy.formTableConfigs.tableData = [].concat(
                proxy.formTableOption.tableData
              );
            }
            proxy.formState = "select";
            proxy.$refs.tableTopRef.clearValidate();
            proxy.formTableOption.tableData.forEach((item) => {
              item._edit = false;
            });
            proxy.$emit("topOperate", data, (res) => {
              proxy.setFormState(res);
            });
            break;
          //保存
          case "save":
            if (proxy.formTableOption.model === "default") {
              return false;
            }
            proxy.$refs.tableTopRef.validate().then((valid) => {
              if (valid) {
                //新增
                if (proxy.formState === "add") {
                  data.table[data.table.length - 1][
                    proxy.formTableOption.majorKey
                  ] = "";
                  proxy.$emit("topOperate", data, (res) => {
                    proxy.setFormState(res);
                    if (res === "select") {
                      proxy.formTableOption.tableData.forEach((item) => {
                        item._edit = false;
                      });
                    }
                  });
                } else {
                  //编辑
                  proxy.$emit("topOperate", data, (res) => {
                    proxy.setFormState(res);
                    if (res === "select") {
                      proxy.formTableOption.tableData.forEach((item) => {
                        item._edit = false;
                      });
                    }
                  });
                }
              }
            });
            break;
          default:
            // //默认提供data数据(顶部表单，操作行),回调可改变页面状态
            proxy.$emit("topOperate", data, (res) => {
              proxy.setFormState(res);
              if (res === "select") {
                proxy.formTableOption.tableData.forEach((item) => {
                  item._edit = false;
                });
              }
            });
            break;
        }
      },
    };

    /* 表格相关方法 */
    const tableFunction = {
      //操作按钮方法
      itemOptions: function (type, row, index, cellKey) {
        var that = proxy;
        let data = {
          type,
          row,
          table: proxy.formTableOption.tableData || "",
          state: proxy.formState || "",
          index,
          cellKey: cellKey || "",
        };
        proxy.editRow = row;
        switch (type) {
          //编辑
          case "edit":
            proxy.formState = "edit";
            if (proxy.formTableOption.model === "default") {
              var editData = proxy.formTableOption.modalConfig.data[0];
              for (var k in proxy.formTemplate) {
                proxy.tableRowFormData[k] = {
                  value: row[k] || proxy.formTemplate[k],
                };
              }
              proxy.formTableOption.modalConfig.editData = editData;
              proxy.$emit("tableOperate", data, (res) => {
                proxy.setFormState(res);
              });
              proxy.formTableOption.modalConfig.show = true;
            } else {
              proxy.$emit("tableOperate", data, (res) => {
                proxy.setFormState(res);
              });
              proxy.formTableOption.tableData[index]._edit = true;
            }
            break;
          //保存
          case "save":
            if (proxy.formTableOption.model === "other") {
              proxy.$refs.tableTopRef.validate().then((valid) => {
                if (valid) {
                  //清空id
                  if (proxy.formState === "add") {
                    data.table[data.table.length - 1][
                      proxy.formTableOption.majorKey
                    ] = "";
                  }
                  //新增
                  proxy.$emit("tableOperate", data, (res) => {
                    proxy.formState = "select";
                    if (res === "select") {
                      proxy.formTableOption.tableData.forEach((item) => {
                        item._edit = false;
                      });
                    }
                  });
                }
              });
            }
            break;
          case "delete":
            that.$confirm({
              title: () => "删除",
              icon: () => createVNode(ExclamationCircleOutlined),
              content: () => "确定要删除吗？",
              cancelText: () => "取消",
              okText: () => "确认",
              onOk() {
                return new Promise((resolve) => {
                  that.$emit("tableOperate", data, (res) => {
                    resolve(true);
                  });
                });
              },
              onCancel() {},
            });
            break;
          default:
            that.$emit("tableOperate", data, (res) => {
              proxy.setFormState(res);
              if (res === "select") {
                proxy.formTableOption.tableData.forEach((item) => {
                  item._edit = false;
                });
              }
            });
            break;
        }
      },
      //选中记录方法
      onSelectChange: function (selectedRowKeys, selectedRows) {
        if (proxy.formState !== "select") {
          return false;
        }
        proxy.selectedData = [];
        proxy.selectedRowKeys = selectedRowKeys;
        //选择直接赋值
        if (selectedRows) {
          proxy.selectedData = selectedRows;
        } else {
          //点击过滤后赋值
          proxy.formTableOption.tableData.forEach((one) => {
            if (
              selectedRowKeys.indexOf(one[proxy.formTableOption.majorKey]) != -1
            ) {
              proxy.selectedData.push({
                ...one,
              });
            }
          });
        }
        //返回选中行，及点击行
        let data = {
          selectedData: proxy.selectedData,
          currentRow: proxy.nowClickRow,
        };
        proxy.$emit("onSelectChange", data);
      },
      // 点击行
      customRow: function (record, index) {
        //合并行属性
        let obj = Object.assign(
          {
            onClick: (event) => {
              if (proxy.formState !== "select") {
                return false;
              }
              //如果配置了单选重置则点击行清空选择
              if (proxy.formTableOption.radioReset) {
                proxy.selectedRowKeys = [];
                proxy.selectedData = [];
                proxy.nowClickRow = {};
              }
              var selId = record[proxy.formTableOption.majorKey],
                selArr = proxy.selectedRowKeys;
              var selIdx = selArr.indexOf(selId);
              if (selArr.length > 1 && selIdx != -1) {
                // 多选
                selArr.splice(selIdx, 1);
              } else if (selArr.length < 2) {
                // 单选
                selArr = [selId];
              }
              proxy.nowClickRow = record;
              proxy.tableFunction.onSelectChange(selArr);
              proxy.$emit("rowClick", record, (res) => {
                proxy.setFormState(res);
              });
            },
          },
          proxy.formTableOption.customRow
            ? proxy.formTableOption.customRow(record, index)
            : ""
        );
        return obj;
      },
      // table 分页数量变更
      tablePageChange: function (page) {
        var form = proxy.$refs["topForm"];
        proxy.$nextTick(() => {
          if (proxy.$refs.hasOwnProperty("tableTopRef")) {
            proxy.$refs.tableTopRef.clearValidate();
          }
        });
        var data = {
          formData: form.getFormData().formData,
          queryParams: {},
        };
        if (proxy.slot.top.length !== 0) {
          proxy.slot.top.forEach((item) => {
            data.formData[item.soltName] =
              proxy.formTableConfigs.slotData[item.soltName] || "";
          });
        }
        proxy.selectedRowKeys = [];
        proxy.selectedData = [];
        data.queryParams = {
          pageNum: proxy.formTableOption.pagination.current,
          pageSize: proxy.formTableOption.pagination.pageSize,
        };
        proxy.$emit("tablePageChange", data, (res) => {
          proxy.setFormState(res);
        });
      },
      //筛选重置方法
      chandleReset: function (clearFilters) {
        clearFilters();
        state.searchText = "";
      },
      //筛选方法
      handleSearch: function (selectedKeys, confirm, dataIndex) {
        confirm();
        state.searchText = selectedKeys[0];
        state.searchedColumn = dataIndex;
      },
      clearAll: function () {
        state.searchText = null;
        state.searchedColumn = null;
      },
    };

    /* modal框方法 */
    const modalFunction = {
      // 表格数据  新增 / 修改
      submitConfig: function (state) {
        if (state) {
          let form = proxy.$refs["rowForm"];
          // 校验表单数据
          form
            .formValidation()
            .then((res) => {
              if (res.state) {
                proxy.formTableOption.modalConfig.loading = true;
                var queryParams = {
                  ...proxy.formTemplate,
                };
                let type = proxy.formState;
                // 合并表单项内容
                queryParams = Object.assign(queryParams, res.form);
                proxy.$emit("tableSubmit", queryParams, type, (ress) => {
                  //后台异常仅修改按钮状态
                  if (ress === "error") {
                    proxy.formTableOption.modalConfig.loading = false;
                  } else {
                    proxy.formState = ress;
                    proxy.formTableOption.modalConfig.loading = false;
                    proxy.formTableOption.modalConfig.show = false;
                    proxy.selectedRowKeys = [];
                    proxy.selectedData = [];
                    proxy.formState = "select";
                  }
                });
              } else {
                proxy.formTableOption.modalConfig.loading = false;
              }
            })
            .catch((err) => {});
          // 校验表单数据
        } else {
          proxy.formTableOption.modalConfig.show = false;
          proxy.formState = "select";
        }
      },
      //关闭或显示modal
      modalShow: function (val) {
        proxy.formTableOption.modalConfig.show = val;
      },
    };
    return {
      topForms,
      optionsObj,
      getOptions,
      topFunction,
      modalFunction,
      editableData,
      tableFunction,
      zhCN,
      ...toRefs(state),
    };
  },
  beforeMount() {
    //设置顶部按钮权限
    (this as any).formTableOption.topBtnList.forEach((item, index, arr) => {
      if (
        item.key === "add" ||
        item.key === "edit" ||
        item.key === "search" ||
        item.key === "reset" ||
        item.key === "save"
      ) {
        (this as any).topPowerList.push(item);
      }
    });
    //设置 上传headers
    (this as any).formTableOption.uploadConfig.headers = {
      Authorization: "Bearer " + sessionStorage.getItem("token"),
    };
    //处理不同model数据
    if (this.formTableOption.model === "default") {
      this.formTemplate = this.formTableOption.formTemplate;
    } else {
      for (const key in this.formTableOption.formTemplate) {
        this.formTemplate[key] = "";
      }
    }
    for (let i = 0; i < (this as any).formTableOption.tableData.length; i++) {
      this.formTableOption.tableData[i]._edit = false;
    }
    //是否配置表格内操作
    if (this.formTableOption.tableBtnWidth) {
      let isHave = (this as any).formTableOption.columns.some((item) => {
        return item.key === "options";
      });
      if (!isHave) {
        (this as any).formTableOption.columns.push({
          width: this.formTableOption.tableBtnWidth,
          title: "操作",
          key: "options",
          align: "center",
          slots: { customRender: "options" },
        });
      }
    }
    // this.formTableConfigs.columns.forEach((item) => {
    //   if (item.hasOwnProperty("onFilter")) {
    //     item.onFilterDropdownVisibleChange = (visible) => {
    //       setTimeout(() => {
    //         this.initBtns();
    //       }, 10);
    //     };
    //   }
    // });
    if (JSON.stringify((this as any).formTableOption.topForm) != "{}") {
      //获取顶部插槽
      (this as any).formTableOption.topForm.form.forEach((item) => {
        if (item.soltName || item.slotName) {
          //调整插槽名称问题
          if (item.slotName) {
            item.soltName = item.slotName;
          }
          (this as any).slot.top.push(item);
        }
      });
    }
    if (JSON.stringify((this as any).formTableOption.tableRowForm) != "{}") {
      //获取弹窗插槽
      (this as any).formTableOption.tableRowForm.form.forEach((item) => {
        if (item.soltName || item.slotName) {
          //调整插槽名称问题
          if (item.slotName) {
            item.soltName = item.slotName;
          }
          (this as any).slot.modal.push(item);
        }
      });
    }
    this.getOptions();
  },
  mounted() {
    let dom = this.$el;
    if (this.formTableOption.showTop && this.formTableOption.pageTitle) {
      this.topFormHeight = dom.querySelector(".topSearchForm").clientHeight;
    }
    window.addEventListener("resize", this.getTableViewHeight);
    setTimeout(() => {
      this.getTableViewHeight();
    });
  },
  methods: {
    //校验默认按钮显示
    disabledTopButton(key) {
      let obj = <any>{};
      (this as any).topPowerList.forEach((item) => {
        if (item.key === key) {
          obj = item;
        }
      });
      if (obj) {
        if (
          Object.prototype.toString.call(obj.disabled) === "[object Function]"
        ) {
          return obj.disabled(this.selectedData, this.formState);
        } else {
          false;
        }
      } else {
        return false;
      }
    },
    //校验默认按钮显示
    noShowTopButton(key) {
      let obj = <any>{};
      (this as any).topPowerList.forEach((item) => {
        if (item.key === key) {
          obj = item;
        }
      });
      if (obj) {
        if (
          Object.prototype.toString.call(obj.noShow) === "[object Function]"
        ) {
          return obj.noShow(this.selectedData, this.formState);
        } else {
          false;
        }
      } else {
        return false;
      }
    },
    // //初始化筛选按钮
    // initBtns() {
    //   if (
    //     document.getElementsByClassName("surely-table-filter-dropdown-btns")
    //   ) {
    //     let btns = document.getElementsByClassName(
    //       "surely-table-filter-dropdown-btns"
    //     ) as any;
    //     for (let i = 0; i < btns.length; i++) {
    //       let cancel = btns[i].getElementsByClassName(
    //         "ant-btn ant-btn-link ant-btn-sm"
    //       )[0];
    //       let submit = btns[i].getElementsByClassName(
    //         "ant-btn ant-btn-primary ant-btn-sm"
    //       )[0];
    //       console.log(cancel.innerHTML)
    //       // cancel.innerHTML = "重置";
    //       // submit.innerHTML = "确认";
    //       // submit.style.width = "44px";
    //       console.log(cancel.innerHTML,1000)

    //     }
    //   }
    // },
    //滚动动画
    animateTo(node, current, target) {
      if (current === target) return;
      clearInterval(node.timer);
      let step = (target - current) / 30;
      let maxHeight = 0;
      step = step > 0 ? Math.ceil(step) : Math.floor(step);
      node.timer = setInterval(() => {
        maxHeight = node.scrollTop;
        node.scrollTop = node.scrollTop + step;
        if (Math.abs(target - node.scrollTop) < Math.abs(step)) {
          node.scrollTop = target;
          clearInterval(node.timer);
        }
        if (maxHeight === node.scrollTop) {
          clearInterval(node.timer);
        }
      }, 15);
    },
    //设置表格滚动条位置
    setScrollHeight(val, animate) {
      setTimeout(() => {
        let ele = <any>null;
        ele = this.$el.querySelector(".tableView");
        let elc = ele.querySelector(".surely-table-body");
        if (animate) {
          this.animateTo(elc, elc.scrollTop, val);
        } else {
          elc.scrollTop = val;
        }
      }, 100);
    },
    //表格过滤改变
    onChange(pagination, filters, sorter) {
      (this.filters = filters || {}), (this.sorter = sorter || {});
      let paginations = {
        pageNum: this.formTableOption.pagination.current,
        pageSize: this.formTableOption.pagination.pageSize,
      };
      let data = {
        paginations: paginations,
        filters,
        sorter,
      };
      this.$emit("filterSortChange", data);
    },
    //表单赋值
    setSingleData(type, key, value) {
      this.$nextTick(() => {
        if (type === "top") {
          (this as any).$refs.topForm.setSingleData(key, value);
        } else if (type === "modal") {
          (this as any).$refs.rowForm.setSingleData(key, value);
        } else {
          console.log("不存在form");
        }
      });
    },
    //获取筛选焦点
    focus(val) {
      (this as any).$refs[val].focus();
    },
    //表格清空校验
    tableClearValidate() {
      return (this as any).$refs.tableTopRef.clearValidate();
    },
    //表格校验方法
    tableValidate() {
      return (this as any).$refs.tableTopRef.validate();
    },
    //处理查询forms数据
    handleFormData(isReset) {
      let form = (this as any).$refs["topForm"]; //获取表单
      if (form) {
        let obj = clone(form.getFormData().formData);
        // let params = {};
        (this as any).formTableOption.tableRowForm.form.forEach((item) => {
          if (item.type === "rangeTime") {
            delete obj[item.name];
          }
          //处理datePicker数据改为对象
          if (item.type === "datePicker") {
            delete obj[item.name];
          }
          if (item.type === "custom") {
            delete obj[item.name];
          }
          // //处理日期范围数据改为对象
          // if (item.type === "rangeTime") {
          //   let arr = obj[item.name] || [];
          //   delete obj[item.name];
          //   if (arr.length !== 0) {
          //     params[item.startName] = arr[0] || "";
          //     params[item.endName] = arr[1] || "";
          //   } else {
          //     params[item.startName] = "";
          //     params[item.endName] = "";
          //   }
          // }
          // //处理datePicker数据改为对象
          // if (item.type === "datePicker") {
          //   let startDate = obj[item.startName] || "";
          //   let endDate = obj[item.endName] || "";
          //   delete obj[item.startName];
          //   delete obj[item.name];
          //   delete obj[item.endName];
          //   params[item.startName] = startDate;
          //   params[item.endName] = endDate;
          // }
          // //是否注入params中
          // if (item.inParams) {
          //   let value = obj[item.name] || "";
          //   delete obj[item.name];
          //   params[item.name] = value;
          // }
        });
        if (isReset) {
          for (const key in obj) {
            obj.key = undefined;
          }
        }
        // obj.params = params
        return obj;
      } else {
        return {};
      }
    },
    //处理modalForm数据
    handleModalFormData(isReset) {
      let form = (this as any).$refs["rowForm"]; //获取表单
      if (form) {
        let obj = clone(form.getFormData().formData);
        // let params = {};
        (this as any).formTableOption.tableRowForm.form.forEach((item) => {
          if (item.type === "rangeTime") {
            delete obj[item.name];
          }
          //处理datePicker数据改为对象
          if (item.type === "datePicker") {
            delete obj[item.name];
          }
          if (item.type === "custom") {
            delete obj[item.name];
          }
          // //处理日期范围数据改为对象
          // if (item.type === "rangeTime") {
          //   let arr = obj[item.name] || [];
          //   delete obj[item.name];
          //   if (arr.length !== 0) {
          //     params[item.startName] = arr[0] || "";
          //     params[item.endName] = arr[1] || "";
          //   } else {
          //     params[item.startName] = "";
          //     params[item.endName] = "";
          //   }
          // }
          // //处理datePicker数据改为对象
          // if (item.type === "datePicker") {
          //   let startDate = obj[item.startName] || "";
          //   let endDate = obj[item.endName] || "";
          //   delete obj[item.startName];
          //   delete obj[item.name];
          //   delete obj[item.endName];
          //   params[item.startName] = startDate;
          //   params[item.endName] = endDate;
          // }
          // //是否注入params中
          // if (item.inParams) {
          //   let value = obj[item.name] || "";
          //   delete obj[item.name];
          //   params[item.name] = value;
          // }
        });
        if (isReset) {
          for (const key in obj) {
            obj.key = undefined;
          }
        }
        // obj.params = params
        return obj;
      } else {
        return {};
      }
    },
    //弹窗点击
    modalClick(val) {
      this.tableFunction.itemOptions("modal", val.record, val.index, val.key);
    },
    //弹窗切换显示隐藏
    modalShow(val) {
      //初始化数据
      if (val) {
        var editData = this.formTableOption.modalConfig.data[0];
        for (var k in this.formTemplate) {
          this.tableRowFormData[k] = {
            value: this.editRow[k] || this.formTemplate[k],
          };
        }
        this.formTableOption.modalConfig.editData = editData;
      }
      this.modalFunction.modalShow(val);
    },
    beforeUpload() {
      //初始化进度条
      loadings = (this as any).$loading({
        background: "rgba(0,0,0,0.75)",
        size: 166,
        iconColor: "#00678C",
      });
    },
    //导入
    upload(info) {
      let data = {
        type: "uploadSuccess",
        formData: (this as any).handleFormData(),
        selectedData: this.selectedData,
        table: this.formTableOption.tableData,
        state: this.formState,
        fileList: [],
        response: {},
      };
      data.fileList = this.formTableOption.uploadConfig.fileList;
      //返回接口结果
      data.response = info.file.response;
      if (info.file.status === "done") {
        if (loadings) {
          loadings.close();
        }
        this.$emit("topOperate", data, (res) => {
          this.setFormState(res);
          if (res === "select") {
            (this as any).formTableOption.tableData.forEach((item) => {
              item._edit = false;
            });
          }
        });
      } else if (info.file.status === "error") {
        if (loadings) {
          loadings.close();
        }
        (this as any).$message.error(`文件导入失败`);
      }
    },
    getData() {
      let data = {
        formData: (this as any).handleFormData(),
        selectedData: this.selectedData,
        table: this.formTableOption.tableData,
        modalData: (this as any).handleModalFormData(),
        state: this.formState,
        filters: this.filters || {},
        sorter: this.sorter || {},
      };
      if (this.slot.top.length !== 0) {
        (this as any).slot.top.forEach((item) => {
          data.formData[item.soltName] =
            this.formTableConfigs.slotData[item.soltName] || "";
        });
      }
      if (this.slot.modal.length !== 0) {
        (this as any).slot.modal.forEach((item) => {
          data.modalData[item.soltName] =
            this.formTableConfigs.slotData[item.soltName] || "";
        });
      }
      return data;
    },
    // 收缩顶部查询表单
    shrinkTopForm: function () {
      if (this.formTableOption.isShrink) {
        let ele = <any>null;
        this.topFormShrink = !this.topFormShrink;
        this.formTableOption.tableViewHeight +=
          this.topFormHeight * (this.topFormShrink ? 1 : -1);
        ele = this.$el.querySelector(".tableView");
        let elc = ele.querySelector(".surely-table-body");
        let wrapper = ele.querySelector(".surely-table-wrapper");
        //无内容高度
        let emty = ele.querySelector(".surely-table-empty-container");
        if ((this as any).formTableOption.tableData.length === 0) {
          elc.style.height = this.formTableOption.tableViewHeight + "px";
          elc.style.minHeight = this.formTableOption.tableViewHeight + "px";
          if (emty) {
            emty.style.height = this.formTableOption.tableViewHeight + "px";
            emty.style.minHeight = this.formTableOption.tableViewHeight + "px";
          }
        } else {
          elc.style.height = this.formTableOption.tableViewHeight + "px";
          elc.style.minHeight = this.formTableOption.tableViewHeight + "px";
          wrapper.style.height = this.formTableOption.tableViewHeight + "px";
          wrapper.style.minHeight = this.formTableOption.tableViewHeight + "px";
        }
      }
      //配置收起表格
      if (this.formTableOption.shrinkTable) {
        this.$el.style.transition = "all 0.5s";
        if (this.topFormShrink) {
          this.$el.style.height = "60px";
          setTimeout(() => {
            this.hiddenTable = !this.topFormShrink;
          }, 501);
        } else {
          this.hiddenTable = !this.topFormShrink;
          this.$el.style.height = "100%";
        }
      }
      this.resetHeight();
      this.$emit("shrinkTable", this.topFormShrink);
    },
    resetHeight() {
      this.getTableViewHeight();
    },
    //表格滚动高度自适应
    getTableViewHeight() {
      let height = 0;
      let ele = <any>null;
      setTimeout(() => {
        this.$nextTick(() => {
          ele = this.$el.querySelector(".tableView");
          height = ele.clientHeight;
          let elc = ele.querySelector(".surely-table-body");
          let wrapper = ele.querySelector(".surely-table-wrapper");
          //顶部行高
          let thead = ele.querySelector(".surely-table-header");
          //无内容高度
          let emty = ele.querySelector(".surely-table-empty-container");
          //分页高度
          let pageHeight = this.formTableOption.showPagination ? 62 : 22;
          let theadHeight = thead.clientHeight;
          this.scrollHeight = height - theadHeight - pageHeight;
          elc.style.minHeight = this.scrollHeight + "px";
          elc.style.height = this.scrollHeight + "px";
          wrapper.style.minHeight = height - pageHeight + "px";
          wrapper.style.height = height - pageHeight + "px";
          if (emty) {
            emty.style.height = height - theadHeight - pageHeight + "px";
            emty.style.minHeight = height - theadHeight - pageHeight + "px";
          }
          this.formTableOption.tableViewHeight =
            height - theadHeight - pageHeight;
        });
      }, 100);
    },
    //表格选中,编辑模式，及form编辑模式重置
    tableReset() {
      this.selectedRowKeys = [];
      this.selectedData = [];
      this.formState = "select";
      (this as any).formTableOption.tableData.forEach((item) => {
        item._edit = false;
      });
    },
    //控件状态赋值
    setFormState(val) {
      if (!val) return;
      if (val === "select" || val === "add" || val === "edit") {
        this.formState = val;
      } else {
        (this as any).$message.error(
          `此组件不支持状态${val}，现有状态select,add,edit`
        );
      }
    },
  },
  watch: {
    // 状态改变更新
    formState: function (newVal, oldVal) {
      //是否存在toolTip配置
      let havetoolTip = false;
      if (newVal === oldVal) {
        return false;
      }
      //行内编辑处理
      if (this.formTableOption.model === "other") {
        //修复tooltip导致的校验的问题
        if (newVal === "add" || newVal === "edit") {
          (this as any).formTableConfigs.columns.forEach((item) => {
            if (item.tooltip && item.hasOwnProperty("tooltip")) {
              havetoolTip = true;
              item.tooltip = false;
            }
          });
        } else {
          (this as any).formTableConfigs.columns.forEach((item) => {
            if (!item.tooltip && item.hasOwnProperty("tooltip")) {
              havetoolTip = true;
              item.tooltip = true;
            }
          });
        }
        //存在才重新渲染
        if (havetoolTip) {
          (this as any).formTableConfigs.tableData = [].concat(
            (this as any).formTableOption.tableData
          );
        }
      }
    },
    //刷新form
    "formTableConfigs.tableData": {
      handler(newVal, oldVal) {
        this.tableData = [].concat(newVal);
        this.getTableViewHeight();
      },
      deep: true,
      immediate: true,
    },
    "formTableConfigs.columns": {
      handler(newVal, oldVal) {
        this.getOptions();
        this.getTableViewHeight();
      },
      deep: true,
      immediate: true,
    },
    topFormShrink: function (newVal, oldVal) {
      if (!this.formTableOption.shrinkTable) {
        this.getTableViewHeight();
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getTableViewHeight);
  },
});
